<div class="custom-dialog-overlay d-flex justify-content-center align-items-center" *ngIf="dialogService.dialogVisible">
    <div class="custom-dialog-box p-4 position-relative">
        <!-- Close Button (Icon) -->
        <button type="button" class="close-button position-absolute" (click)="dialogService.hideDialog()">
            <i class="bi bi-x-circle"></i> <!-- Bootstrap Icon -->
        </button>

        <!-- OTP Verification Header -->
        <p class="container-paragraph font-weight-bold text-center">
            OTP Verification
        </p>

        <div *ngIf="this.dialogService.isProcessCompleted">
            <div class="success-icon mb-4 d-flex justify-content-center align-items-center">
                <svg width="200" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_739_60156)">
          <path d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z" stroke="#006538" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.5 12.5L11.5 14.5L14.5 11.5" stroke="#006538" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_739_60156">
            <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
          </clipPath>
        </defs>
      </svg>
            </div>



            <div class="otp-message text-center mb-3">
                <label class="otp-label"> {{successMessage}}</label>
            </div>

        </div>


        <!-- OTP Form -->
        <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" *ngIf="!this.dialogService.isProcessCompleted">








            <div class="otp-image mb-4 text-center">
                <img src="assets/img/Bidaya-long.png" class="otp-BackGround img-fluid" alt="Bidaya Home Finance">
            </div>

            <div class="otp-message text-center mb-3">
                <label class="otp-label"> Kindly enter the OTP sent to your registered email and mobile number </label>
            </div>

            <div class="otp-digits d-flex justify-content-center mb-4">
                <input type="text" class="otp-input form-control mx-1 text-center" maxlength="1" formControlName="otp1" autofocus appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp1')" inputmode="numeric">
                <input type="text" class="otp-input form-control mx-1 text-center" maxlength="1" formControlName="otp2" appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp2')" inputmode="numeric">
                <input type="text" class="otp-input form-control mx-1 text-center" maxlength="1" formControlName="otp3" appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp3')" inputmode="numeric">
                <input type="text" class="otp-input form-control mx-1 text-center" maxlength="1" formControlName="otp4" appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp4')" inputmode="numeric">
                <input type="text" class="otp-input form-control mx-1 text-center" maxlength="1" formControlName="otp5" appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp5')" inputmode="numeric">
                <input type="text" class="otp-input form-control mx-1 text-center" maxlength="1" formControlName="otp6" appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp6')" inputmode="numeric">
            </div>

            <div class="text-danger text-center" *ngIf="dialogService.otpError">
                {{ dialogService.otpError }}
            </div>

            <div class="text-success text-center" *ngIf="dialogService.resendSuccess">
                {{ dialogService.resendSuccessMessage }}
            </div>

            <div class="text-danger text-center" *ngIf="dialogService.resendError">
                {{ dialogService.resendErrorMessage }}
            </div>

            <div class="submition d-flex justify-content-center mt-4">
                <button type="submit" class="submit-btn btn" style="background-color: #532E60; color: white;">Submit</button>
            </div>

            <div class="resend-otp mt-3 text-center">
                <p>If your code has expired, <a (click)="resendOTP()" style="color: #007bff; text-decoration: underline; cursor: pointer;">click here</a> to resend OTP.</p>
            </div>





        </form>
    </div>
</div>
